'use client';

const testimonials = [
  { quote: "Figured out in 7 minutes that I\'d been studying the wrong half of cellular respiration.", name: "Priya M., Pre-med freshman, UMich" },
  { quote: "The Krebs cycle finally clicked after the mnemonic pack. I\'d been staring at Campbell\'s for three weeks.", name: "Jordan T., AP Bio, junior" },
  { quote: "Got a 5. The diagnostic told me exactly what to ignore and what to drill.", name: "Sofia R., AP Bio 2025" },
  { quote: "Used it the week before clinicals. Passed the assessment with margin to spare.", name: "Marcus O., Nursing student, NYU" },
  { quote: "It\'s like having the smartest kid in the library explain it to you without the attitude.", name: "Ananya K., Pre-med sophomore" },
  { quote: "My topic map was basically a confession of everything I\'d been avoiding.", name: "Liam C., AP Bio, senior" },
];

interface TestimonialStripProps {
  variant?: 'light' | 'dark';
}

export default function TestimonialStrip({ variant = 'light' }: TestimonialStripProps) {
  const doubled = [...testimonials, ...testimonials];

  return (
    <div
      className={`py-12 overflow-hidden ${
        variant === 'dark' ? 'bg-ink' : 'bg-cream-dark'
      }`}
    >
      <div className="relative">
        <div className="flex gap-12 marquee-track whitespace-nowrap">
          {doubled.map((t, i) => (
            <div
              key={i}
              className="flex-shrink-0 flex items-center gap-4 px-8"
            >
              <span className={`handwritten text-xl ${variant === 'dark' ? 'text-cream/80' : 'text-ink-light'}`}>
                "{t.quote}"
              </span>
              <span className={`text-xs font-medium tracking-wide flex-shrink-0 ${variant === 'dark' ? 'text-amber' : 'text-mauve'}`}>
                — {t.name}
              </span>
              <span className={`mx-4 text-2xl ${variant === 'dark' ? 'text-cream/20' : 'text-ink-muted/30'}`}>✦</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}